import React from 'react';

import {
  GENESIS_TEST_ACCOUNTS,
  GENESIS_TEST_PASSWORD,
} from '../../../config/genesisTestAccounts';

import css from './GenesisTestAccountsPanel.module.css';

const GenesisTestAccountsPanel = () => {
  return (
    <aside className={css.root} aria-label="Genesis test accounts">
      <h3 className={css.heading}>Genesis test accounts</h3>
      <p className={css.passwordNote}>
        Password for all accounts: <code className={css.code}>{GENESIS_TEST_PASSWORD}</code>
      </p>
      <ul className={css.list}>
        {GENESIS_TEST_ACCOUNTS.map(account => (
          <li key={account.email} className={css.item}>
            <span className={css.label}>{account.label}</span>
            <code className={css.code}>{account.email}</code>
            <span className={css.role}>{account.role}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default GenesisTestAccountsPanel;
